<div
  class="flex flex-row gap-2 overflow-hidden w-85vw md:w-[300px] lg:w-[350px]"
>
  <kendo-avatar
    class="mr-3"
    fillMode="outline"
    [border]="false"
    size="large"
    [themeColor]="themeColor"
    iconClass="fa-duotone {{ icon }}"
    shape="square"
  ></kendo-avatar>
  <div class="grid w-full grid-flow-col gap-0">
    <div class="w-full">
      @if (title) {
        <h3 class="font-bold {{ color }}">
          {{ title | translate }}
        </h3>
      }
      @if (message) {
        <p>
          {{ message | translate }}
        </p>
      }
    </div>
  </div>
  <kendo-progressbar
    [value]="progressBarValue"
    [animation]="animation"
    [label]="false"
    [progressCssClass]="this.bgColor"
    [emptyCssClass]="'bg-white'"
    (animationEnd)="ignoreNotification($event)"
    class="w-[93%] h-1 absolute bottom-0 left-3 overflow-hidden"
  >
  </kendo-progressbar>
</div>
